import { ChatGroup } from './ChatGroup'

export const getChannelAPI = function (chatGroup: ChatGroup): string {
  switch (chatGroup) {
    case ChatGroup.PICKING:
      return 'CL_SH'
    case ChatGroup.SUPPORT:
      return 'CL_SUP'
    case ChatGroup.RESOURCE:
      return 'SH_SUP'
  }
}
